export default "__VITE_ASSET__a10b65da__"